









































































import VueMultiselect from 'vue-multiselect';
import BuilderFormGroup from "@tool/Builder/sections/BuilderFormGroup.vue";

import {defineComponent, PropType, ref} from "@vue/composition-api";
import {NewParameterDisplay, SelectOption} from "@tool/Components/SelectDropdownInit";


export default defineComponent({
  components: {
    VueMultiselect,
    BuilderFormGroup
  },
  emits: [
    'changed',
    'opened',
    'created',
    'clear',
  ],
  props: {
    horizontal: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    value: {
      type: Object
    },
    options: {
      type: Array as PropType<SelectOption[]>,
      required: true
    },
    placeholderText: {
      type: String,
      required: true
    },
    noOptionsText: {
      type: String,
      required: true
    },
    taggable: {
      type: Boolean,
      default: false
    },
    newParameterDisplay: {
      type: Object as PropType<NewParameterDisplay>,
      required: false,
    },
    disableClear: {
      type: Boolean,
      required: false
    }
  },
  setup(props, {emit}) {
    const elementClass = `builder-${props.type}`;

    const onChange = (value: SelectOption) => {
      emit('changed', value);
    }

    // To help with builder guide
    const onOpen: () => void = () => {
      emit('opened');
    }

    const onAdd: (value: string) => void = (value) => {
      emit('created', value);
    }

    const devMode = process.env.MIX_DEV_MODE ? process.env.MIX_DEV_MODE === 'true' : false;

    const devSelectValue = ref(null);
    const devSelectElementClass = `${elementClass}-dev`;


    const devOnInput: (value: string) => void = (value) => {
      let result = props.options.find((item) => {
        return item.name === value;
      });

      if (!result) {
        throw new Error('Option does not exist!');
      }

      onChange(result);

    }

    return {
      elementClass,
      onChange,
      onOpen,
      onAdd,


      // Dev
      devMode,
      devSelectValue,
      devSelectElementClass,
      devOnInput,

      //
    }
  }
});
